import { RequestUtils } from "utils";

import { apiAxios, osmAxios, pureApiAxios } from "./apiAxios";

/**
 * Requests for unauthenticated users
 */
export const PublicRequests = new RequestUtils(pureApiAxios);
/**
 * Requests for authenticated users
 */
export const ApiRequests = new RequestUtils(apiAxios);
/**
 * Requests for open source map
 */
export const OSMRequests = new RequestUtils(osmAxios);
